import _styled from "@emotion/styled-base";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import { jsx } from '@emotion/core';
import { FONT, GRID } from '../../constants';
var defaultSize = 'regular';
var defaultMargin = 'xsmall';

var StyledParagraph = _styled("p", {
  target: "ex58t5z0",
  label: "StyledParagraph"
})({
  fontFamily: FONT.family,
  textAlign: 'left',
  fontWeight: 400,
  margin: 0,
  '& b, & strong': {
    fontWeight: FONT.weight.bold
  }
}, function (props) {
  return __assign({
    marginBottom: props.margin ? GRID[props.margin] : GRID[defaultMargin]
  }, props.size ? FONT.sizes[props.size] : FONT.sizes[defaultSize]);
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlBhcmFncmFwaC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFnQnNCIiwiZmlsZSI6IlBhcmFncmFwaC5qcyIsInNvdXJjZXNDb250ZW50IjpbInZhciBfX2Fzc2lnbiA9ICh0aGlzICYmIHRoaXMuX19hc3NpZ24pIHx8IGZ1bmN0aW9uICgpIHtcbiAgICBfX2Fzc2lnbiA9IE9iamVjdC5hc3NpZ24gfHwgZnVuY3Rpb24odCkge1xuICAgICAgICBmb3IgKHZhciBzLCBpID0gMSwgbiA9IGFyZ3VtZW50cy5sZW5ndGg7IGkgPCBuOyBpKyspIHtcbiAgICAgICAgICAgIHMgPSBhcmd1bWVudHNbaV07XG4gICAgICAgICAgICBmb3IgKHZhciBwIGluIHMpIGlmIChPYmplY3QucHJvdG90eXBlLmhhc093blByb3BlcnR5LmNhbGwocywgcCkpXG4gICAgICAgICAgICAgICAgdFtwXSA9IHNbcF07XG4gICAgICAgIH1cbiAgICAgICAgcmV0dXJuIHQ7XG4gICAgfTtcbiAgICByZXR1cm4gX19hc3NpZ24uYXBwbHkodGhpcywgYXJndW1lbnRzKTtcbn07XG5pbXBvcnQgeyBqc3ggfSBmcm9tICdAZW1vdGlvbi9jb3JlJztcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCB7IEZPTlQsIEdSSUQgfSBmcm9tICcuLi8uLi9jb25zdGFudHMnO1xudmFyIGRlZmF1bHRTaXplID0gJ3JlZ3VsYXInO1xudmFyIGRlZmF1bHRNYXJnaW4gPSAneHNtYWxsJztcbnZhciBTdHlsZWRQYXJhZ3JhcGggPSBzdHlsZWQucCh7XG4gICAgZm9udEZhbWlseTogRk9OVC5mYW1pbHksXG4gICAgdGV4dEFsaWduOiAnbGVmdCcsXG4gICAgZm9udFdlaWdodDogNDAwLFxuICAgIG1hcmdpbjogMCxcbiAgICAnJiBiLCAmIHN0cm9uZyc6IHtcbiAgICAgICAgZm9udFdlaWdodDogRk9OVC53ZWlnaHQuYm9sZCxcbiAgICB9LFxufSwgZnVuY3Rpb24gKHByb3BzKSB7IHJldHVybiAoX19hc3NpZ24oeyBtYXJnaW5Cb3R0b206IHByb3BzLm1hcmdpbiA/IEdSSURbcHJvcHMubWFyZ2luXSA6IEdSSURbZGVmYXVsdE1hcmdpbl0gfSwgKHByb3BzLnNpemUgPyBGT05ULnNpemVzW3Byb3BzLnNpemVdIDogRk9OVC5zaXplc1tkZWZhdWx0U2l6ZV0pKSk7IH0pO1xudmFyIFBhcmFncmFwaCA9IGZ1bmN0aW9uIChfYSkge1xuICAgIHZhciBjaGlsZHJlbiA9IF9hLmNoaWxkcmVuLCBfYiA9IF9hLnNpemUsIHNpemUgPSBfYiA9PT0gdm9pZCAwID8gZGVmYXVsdFNpemUgOiBfYiwgX2MgPSBfYS5tYXJnaW4sIG1hcmdpbiA9IF9jID09PSB2b2lkIDAgPyBkZWZhdWx0TWFyZ2luIDogX2MsIGNsYXNzTmFtZSA9IF9hLmNsYXNzTmFtZTtcbiAgICByZXR1cm4gKGpzeChTdHlsZWRQYXJhZ3JhcGgsIHsgc2l6ZTogc2l6ZSwgbWFyZ2luOiBtYXJnaW4sIGNsYXNzTmFtZTogY2xhc3NOYW1lIH0sIGNoaWxkcmVuKSk7XG59O1xuZXhwb3J0IGRlZmF1bHQgUGFyYWdyYXBoO1xuIl19 */");

var Paragraph = function Paragraph(_a) {
  var children = _a.children,
      _b = _a.size,
      size = _b === void 0 ? defaultSize : _b,
      _c = _a.margin,
      margin = _c === void 0 ? defaultMargin : _c,
      className = _a.className;
  return jsx(StyledParagraph, {
    size: size,
    margin: margin,
    className: className
  }, children);
};

export default Paragraph;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/Type/Paragraph.js
// module id = 812
// module chunks = 0